import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import moment from 'moment';

// Query for annual tickets count
const GET_ANNUAL_TICKETS_COUNT = gql`
  query GetAllAnnualTickets($getAnnualTicketsInput: GetAnnualTicketsInput!) {
    getAllAnnualTickets(input: $getAnnualTicketsInput) {
      count
    }
  }
`;

// Query for categories count
const GET_CATEGORIES_COUNT = gql`
  query GetAnnualTypesAdmin($input: GetAnnualTypesInput!) {
    getAnnualTypesAdmin(input: $input) {
      count
    }
  }
`;

// Query for members count
const GET_MEMBERS_COUNT = gql`
  query GetAccountMembers($input: AccountMembersInput!) {
    getAccountMembers(input: $input) {
      count
    }
  }
`;

// Query for annual purchases count
const GET_PURCHASES_COUNT = gql`
  query GetAccountAnnuals($input: AccountMembersInput!) {
    getAccountAnnuals(input: $input) {
      count
    }
  }
`;

// Custom hook to get all hub stats for an account
export function useGetAccountAnnualsStats(accountId) {
  const currentYear = Number(moment().format('YYYY'));

  const { data: ticketsData, loading: ticketsLoading } = useQuery(
    GET_ANNUAL_TICKETS_COUNT,
    {
      variables: {
        getAnnualTicketsInput: {
          accountFilter: accountId,
          year: currentYear,
        },
      },
      skip: !accountId,
      fetchPolicy: 'cache-and-network',
    }
  );

  const { data: categoriesData, loading: categoriesLoading } = useQuery(
    GET_CATEGORIES_COUNT,
    {
      variables: {
        input: {
          accountFilter: accountId,
        },
      },
      skip: !accountId,
      fetchPolicy: 'cache-and-network',
    }
  );

  const { data: membersData, loading: membersLoading } = useQuery(
    GET_MEMBERS_COUNT,
    {
      variables: {
        input: {
          account_id: accountId,
          year: currentYear,
        },
      },
      skip: !accountId,
      fetchPolicy: 'cache-and-network',
    }
  );

  const { data: purchasesData, loading: purchasesLoading } = useQuery(
    GET_PURCHASES_COUNT,
    {
      variables: {
        input: {
          account_id: accountId,
          year: currentYear,
        },
      },
      skip: !accountId,
      fetchPolicy: 'cache-and-network',
    }
  );

  return {
    ticketsCount: ticketsData?.getAllAnnualTickets?.count ?? 0,
    categoriesCount: categoriesData?.getAnnualTypesAdmin?.count ?? 0,
    membersCount: membersData?.getAccountMembers?.count ?? 0,
    purchasesCount: purchasesData?.getAccountAnnuals?.count ?? 0,
    loading:
      ticketsLoading || categoriesLoading || membersLoading || purchasesLoading,
  };
}
